module.exports = __webpack_public_path__ + "static/media/student_spritemap-42x64.1999233c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/studentPilot/student_spritemap-42x64.png
// module id = 863
// module chunks = 0